import { render, staticRenderFns } from "./CategoryContentSettings.pug?vue&type=template&id=58a73434&lang=pug&external"
import script from "./CategoryContentSettings.js?vue&type=script&lang=js&external"
export * from "./CategoryContentSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports